// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1mcPX","boxTitle":"Qualiphy_boxTitle__PKYex","box":"Qualiphy_box__18au9","toggleWrap":"Qualiphy_toggleWrap__NoTtc"};